import { cn } from "@devhop/ui";
import { Receipt, ScrollText } from "lucide-react";

export type SellPackageSettlementMode = "receipt" | "credit";

type SellPackageSettlementModeRadioProps = {
  value: SellPackageSettlementMode;
  onChange: (value: SellPackageSettlementMode) => void;
  onBlur?: () => void;
  name?: string;
  disabled?: boolean;
  label?: string;
};

export function SellPackageSettlementModeRadio({
  value,
  onChange,
  onBlur,
  name = "settlementMode",
  disabled = false,
  label = "ຮູບແບບການເງິນ",
}: SellPackageSettlementModeRadioProps) {
  return (
    <fieldset className="min-w-0 border-0 p-0">
      <legend className="mb-2 font-medium text-sm">{label}</legend>
      <div className="grid gap-3 sm:grid-cols-2">
        <label
          className={cn(
            "flex cursor-pointer gap-3 rounded-lg border p-4 text-left ring-offset-background transition-colors focus-within:outline-none focus-within:ring-2 focus-within:ring-red-600 focus-within:ring-offset-2",
            disabled && "cursor-not-allowed opacity-60",
            value === "receipt"
              ? "border-red-600 bg-muted/50"
              : "border-border hover:bg-muted/30",
          )}
        >
          <input
            type="radio"
            name={name}
            value="receipt"
            checked={value === "receipt"}
            disabled={disabled}
            onChange={() => onChange("receipt")}
            onBlur={onBlur}
            className="sr-only"
          />
          <Receipt
            className={cn(
              "mt-0.5 size-5 shrink-0 stroke-[1.5]",
              value === "receipt" ? "text-red-600" : "text-muted-foreground",
            )}
            aria-hidden
          />
          <span className="min-w-0 space-y-1">
            <span className="block font-semibold text-sm leading-tight">
              ໃບເກັບເງິນເຕັມ
            </span>
            <span className="block text-muted-foreground text-xs leading-snug">
              ຊຳລະຄົບຕາມລາຄາສຸດທ້າຍ
            </span>
          </span>
        </label>
        <label
          className={cn(
            "flex cursor-pointer gap-3 rounded-lg border p-4 text-left ring-offset-background transition-colors focus-within:outline-none focus-within:ring-2 focus-within:ring-red-600 focus-within:ring-offset-2",
            disabled && "cursor-not-allowed opacity-60",
            value === "credit"
              ? "border-red-600 bg-muted/50"
              : "border-border hover:bg-muted/30",
          )}
        >
          <input
            type="radio"
            name={name}
            value="credit"
            checked={value === "credit"}
            disabled={disabled}
            onChange={() => onChange("credit")}
            onBlur={onBlur}
            className="sr-only"
          />
          <ScrollText
            className={cn(
              "mt-0.5 size-5 shrink-0 stroke-[1.5]",
              value === "credit" ? "text-red-600" : "text-muted-foreground",
            )}
            aria-hidden
          />
          <span className="min-w-0 space-y-1">
            <span className="block font-semibold text-sm leading-tight">
              ໃບເກັບເງິນ / ຊຳລະບາງສ່ວນ
            </span>
            <span className="block text-muted-foreground text-xs leading-snug">
              ຮັບເງິນບາງສ່ວນຕອນຂາຍ ຫຼື ຕິດຕາມທີ່ໜ້າບິນ
            </span>
          </span>
        </label>
      </div>
    </fieldset>
  );
}
